import clsx from 'clsx';
import type { ReactNode } from 'react';

const EMPTY = {
  md: 'px-4 py-10 text-center text-sm',
  sm: 'py-6 text-center text-xs',
  line: 'text-xs',
} as const;

export function Empty({
  size = 'md',
  boxed = false,
  className,
  children,
}: {
  size?: keyof typeof EMPTY;
  boxed?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <p
      className={clsx(
        EMPTY[size],
        'text-ink-faint',
        boxed && 'rounded-box border border-dashed border-line',
        className,
      )}
    >
      {children}
    </p>
  );
}
